import { render, staticRenderFns } from "./ldForgotPassword.vue?vue&type=template&id=2ff3eab0&scoped=true"
import script from "./ldForgotPassword.vue?vue&type=script&lang=js"
export * from "./ldForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ldForgotPassword.vue?vue&type=style&index=0&id=2ff3eab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff3eab0",
  null
  
)

export default component.exports